"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FetchResponseError = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _first = _interopRequireDefault(require("lodash/fp/first"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _compare = require("@active/core/address/compare");
var _transformer = require("./transformer");
var _excluded = ["error"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var APS_AVS_SERVICE_VERSION = 'application/vnd.active.avs-service.v1+json';
var getVerifyResult = (0, _compose["default"])(_first["default"], (0, _prop["default"])('addressesToVerifiedResult'));
var FetchResponseError = exports.FetchResponseError = /*#__PURE__*/function (_Error) {
  function FetchResponseError(message, status) {
    var _this;
    (0, _classCallCheck2["default"])(this, FetchResponseError);
    _this = _callSuper(this, FetchResponseError, [message]);
    _this.status = status;
    _this.code = status;
    Object.setPrototypeOf(_this, FetchResponseError.prototype);
    return _this;
  }
  (0, _inherits2["default"])(FetchResponseError, _Error);
  return (0, _createClass2["default"])(FetchResponseError);
}(/*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
var createAVS = function createAVS(_ref) {
  var url = _ref.url;
  return {
    correct: function correct(address, extendCorrectionRequest) {
      return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var normalRequestInit, correctRequestInit, fetchResponse, responseData, _getVerifyResult, error, result, correction;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              normalRequestInit = {
                method: 'post',
                headers: {
                  'Content-Type': APS_AVS_SERVICE_VERSION,
                  Accept: 'application/json, text/plain, */*'
                },
                body: JSON.stringify({
                  addressesToBeVerified: [(0, _transformer.transformToAVSAddress)(address)]
                })
              };
              _context.next = 3;
              return extendCorrectionRequest === null || extendCorrectionRequest === void 0 ? void 0 : extendCorrectionRequest(normalRequestInit);
            case 3:
              correctRequestInit = _context.sent;
              _context.next = 6;
              return fetch(url, _objectSpread(_objectSpread({}, normalRequestInit), correctRequestInit));
            case 6:
              fetchResponse = _context.sent;
              if (fetchResponse.ok) {
                _context.next = 9;
                break;
              }
              throw new FetchResponseError(fetchResponse.statusText, fetchResponse.status);
            case 9:
              _context.next = 11;
              return fetchResponse.json();
            case 11:
              responseData = _context.sent;
              _getVerifyResult = getVerifyResult(responseData), error = _getVerifyResult.error, result = (0, _objectWithoutProperties2["default"])(_getVerifyResult, _excluded);
              correction = (0, _transformer.transformToCoreAddress)(result);
              return _context.abrupt("return", {
                isCorrect: !error && (0, _compare.isEqual)(address)(correction),
                source: address,
                correction: correction,
                error: error && {
                  description: (0, _prop["default"])('description')(error)
                }
              });
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  };
};
var _default = exports["default"] = createAVS;